import { useEffect, useState } from "react";
import { createUser, getRoles } from "../api/adminApi";

const AddUserDrawer = ({ onClose, onSaved }) => {

  const [roles, setRoles] = useState([]);

  const [form, setForm] = useState({
    userCode: "",
    name: "",
    email: "",
    password: "",
    roles: []
  });

  useEffect(() => {
    getRoles().then(res => setRoles(res.data));
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const toggleRole = (roleID) => {

    const exists = form.roles.includes(roleID);

    setForm({
      ...form,
      roles: exists
        ? form.roles.filter(r => r !== roleID)
        : [...form.roles, roleID]
    });
  };

  const handleSave = async () => {

    await createUser(form);

    onSaved();
    onClose();
  };

  return (
    <div className="fixed top-0 right-0 w-[420px] h-full bg-white shadow-2xl p-6 z-50 overflow-y-auto">

      <h2 className="text-xl font-black mb-6">
        Add User
      </h2>

      <div className="space-y-4">

        <form autoComplete="off"></form>

        <input
          name="userCode"
          autoComplete="off"                 
          placeholder="User Code"
          onChange={handleChange}
          className="w-full border rounded-lg p-3"
        />

        <input
          name="name"
          placeholder="Name"
          autoComplete="off"
          onChange={handleChange}
          className="w-full border rounded-lg p-3"
        />

        <input
          name="userEmail"
          autoComplete="new-emai"
          placeholder="Email"
          onChange={handleChange}
          className="w-full border rounded-lg p-3"
        />

        <input
          type="password"
          name="newPassword"
          autoComplete="new-password"
          placeholder="Password"
          onChange={handleChange}
          className="w-full border rounded-lg p-3"
        />

        {/* ================= ROLE SELECTION ================= */}

        <div>
          <p className="font-bold mb-2">Assign Roles</p>

          <div className="space-y-2">

            {roles.map(role => (
              <label
                key={role.RoleID}
                className="flex items-center gap-2"
              >
                <input
                  type="checkbox"
                  checked={form.roles.includes(role.RoleID)}
                  onChange={() => toggleRole(role.RoleID)}
                />
                {role.RoleName}
              </label>
            ))}

          </div>
        </div>

        <button
          onClick={handleSave}
          className="w-full bg-blue-950 text-white py-3 rounded-lg font-bold"
        >
          Create User
        </button>

        <button
          onClick={onClose}
          className="w-full border py-3 rounded-lg"
        >
          Cancel
        </button>

      </div>
    </div>
  );
};

export default AddUserDrawer;